import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-change-log',
  templateUrl: './change-log.component.html',
  styleUrls: ['./change-log.component.scss'],
  standalone: false,
})
export class ChangeLogComponent {
  @Input() changeLog!: any;
}
